export default __webpack_public_path__ + "static/media/fasting_18_6@3x.3e70ee07.jpg";